export default "__VITE_ASSET__BKB5gKal__"